export enum AuthorizedPartyStatus {
    Submitted = 'Submitted',
    CompliancePassed = 'CompliancePassed',
    Booked = 'Booked',
    Signing = 'Signing'
}
